import * as React from "react";
import PropTypes from "prop-types";
import styles from "./product-title.module.scss";

/**
 * Displays the PDP Product Title.
 * Derives multiple lines per `*` in the `title` string.
 *
 * @example
 * <ProductTitle title="Product Title*Second Line" />
 */
export default function ProductTitle({ className, createEncodedKey, title }) {
  if (typeof title !== "string") return;
  const lines = title.split("*");
  return (
    <h1 className={`OneLinkNoTx ${styles.title} ${className}`}>
      {lines.map((line) => (
        <div key={createEncodedKey && createEncodedKey(line)}>{line}</div>
      ))}
    </h1>
  );
}

ProductTitle.propTypes = {
  title: PropTypes.string.isRequired
};
